import {forwardRef} from 'react';
import type {CustomFeedbackIconProps} from './custom-feedback-icon.types';
import styles from './custom-feedback-icon.module.scss';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export const CustomFeedbackIcon = forwardRef<HTMLDivElement, CustomFeedbackIconProps>(({svg, tooltipText, cursorClassname, className, ...props}, ref) => {
  const mergedClassName = `spacing-p-2 flex-center ${cursorClassname ?? ''} ${styles.customIcon} ${className ?? ''}`.trim();

  if (tooltipText) {
    return (
      <OverlayTrigger
        trigger={['hover', 'focus']}
        overlay={<Tooltip className={`spacing-m-b-1 _rounded-arrow ${styles.tooltip}`}>{tooltipText}</Tooltip>}
        delay={{show: 0, hide: 0}}
        placement="top"
        offset={undefined}
      >
        <div ref={ref} className={mergedClassName} {...props}>
          {svg}
        </div>
      </OverlayTrigger>
    );
  }

  return (
    <div ref={ref} className={mergedClassName} {...props}>
      {svg}
    </div>
  );
});

CustomFeedbackIcon.displayName = 'CustomFeedbackIcon';
